export default {
    title: '课堂结果',

    sessionInfo: {
        title: '基本信息',
        items: {
            date: '课堂日期',
            duration: '进行时间',
            studentCount: '参与',
        },
        durationFormat: '{startTime} ~ {endTime} ({duration}分钟)',
    },
    curriculumInfo: {
        title: '课名称',
    },

    summary: {
        title: '活动信息',
        completedActivity: '已进行的活动',
        headers: {
            activity: '活动',
            achievement: '达成率',
        },
    },

    studentResults: {
        title: '每位学生正确数及 MVP',
        mvp: 'MVP',
        headers: {
            student: '学生',
            answers: '正确数',
            score: '分数',
        },
    },

    actions: {
        close: '关闭窗口',
        print: '打印',
        export: '导出',
    },

    errors: {
        windowClose: '发生错误。请手动关闭窗口。',
    },
};
